// Renders LoopState.currentDay as a fantasy calendar date. The underlying
// simulation stays a simple incrementing day counter (per
// GAME_CREATION_INSTRUCTIONS.md's deterministic world simulation) — this
// module only maps that counter to a weekday/week/year for display.

const WEEKDAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
]

const DAYS_PER_WEEK = 7
const WEEKS_PER_YEAR = 52
const DAYS_PER_YEAR = DAYS_PER_WEEK * WEEKS_PER_YEAR

// Day 1 — the morning the loop always begins — falls on a Wednesday in the
// year 4523.
const STARTING_WEEKDAY_INDEX = WEEKDAY_NAMES.indexOf("Wednesday")
const STARTING_YEAR = 4523

export interface CalendarDate {
  weekday: string
  weekOfYear: number
  year: number
}

export function getCalendarDate(day: number): CalendarDate {
  const daysSinceStart = Math.max(0, day - 1)
  return {
    weekday: WEEKDAY_NAMES[(STARTING_WEEKDAY_INDEX + daysSinceStart) % DAYS_PER_WEEK],
    weekOfYear: (Math.floor(daysSinceStart / DAYS_PER_WEEK) % WEEKS_PER_YEAR) + 1,
    year: STARTING_YEAR + Math.floor(daysSinceStart / DAYS_PER_YEAR),
  }
}

export function formatCalendarDate(day: number): string {
  const { weekday, weekOfYear, year } = getCalendarDate(day)
  return `${weekday}, Week ${weekOfYear}, Year ${year}`
}

/**
 * The day counter itself, which is the unit every piece of foreknowledge in
 * the game is expressed in — journal entries say "on the twenty-second day",
 * events are scheduled by day number, and the deadline is Day 512. The
 * fantasy calendar above is flavour; this is what the player plans against,
 * so it must never be the thing that gets left off a readout.
 */
export function formatDay(day: number): string {
  return `Day ${day}`
}

export function formatDayAndDate(day: number): string {
  return `${formatDay(day)} · ${formatCalendarDate(day)}`
}
